<template>
  <div class="imgPerIn">
    <div class="imgPerIn-hd">
      <div class="g-box" v-if="list.length">
        <div class="hd-left">
          <div class="hd-cap">{{ list[ind].title }}</div>
          <div class="hd-tit">{{ list[ind].tips }}</div>
          <div class="hd-text" v-html="list[ind].content"></div>
        </div>
        <div class="hd-ban">
          <div
            v-for="(item, index) in list"
            :key="index"
            class="hd-ban-item m-h"
            :class="{ on: ind === index }"
            :style="{
              backgroundImage: 'url(' + item.image + ')'
            }"
            @click="ind = index"
            v-show="index < 3"
          ></div>
        </div>
      </div>
    </div>
    <div class="imgPerIn-list">
      <div
        v-for="(item, index) in list"
        :key="index"
        class="list-item"
        v-show="index >= 3"
      >
        <div class="g-box">
          <div
            class="list-item-img"
            :style="{
              backgroundImage: 'url(' + item.image + ')'
            }"
          ></div>
          <div class="list-item-cent">
            <div class="list-item-cap">{{ item.title }}</div>
            <div class="list-item-tit">{{ item.tips }}</div>
          </div>
          <div class="list-item-text" v-html="item.content"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pageMain_mx from "../../mixins/pageMain_mx";

export default {
  mixins: [pageMain_mx],
  data() {
    return {
      pageSize: 10000000,
      ind: 1
    };
  },
  components: {},
  mounted() {},
  methods: {
    async init() {
      this.params = this.$route.params;
      await this.getListAndInfo();
    }
  }
};
</script>
<style lang="less">
.imgPerIn {
  padding: 80px 0;
}
.imgPerIn-hd {
  background-color: #f2f3f7;
  padding: 80px 0;
  min-height: 590px;
  .g-box {
    display: flex;
  }
  .hd-left {
    width: 672px;
    flex-shrink: 0;
  }
  .hd-cap {
    color: #282828;
    font-size: 24px;
  }
  .hd-tit {
    color: #606060;
    font-size: 16px;
    margin-top: 5px;
  }
  .hd-ban {
    flex-grow: 1;
    margin-left: 111px;
    position: relative;
  }
  .hd-ban-item {
    position: absolute;
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    &.on {
      &:after {
        display: block;
      }
    }
    &:after {
      display: none;
      content: "";
      position: absolute;
      left: 0;
      top: 0;
      background: url("../../assets/img/ico_22.png") no-repeat;
      background-size: 100% 100%;
      width: 100%;
      height: 100%;
    }
    &:nth-child(1) {
      right: 115px;
      top: -30px;
      width: 187px;
      height: 216px;
    }
    &:nth-child(2) {
      top: 147px;
      right: 210px;
      width: 254px;
      height: 292px;
      z-index: 4;
    }
    &:nth-child(3) {
      right: 115px;
      top: 400px;
      width: 187px;
      height: 216px;
    }
    /*&:nth-child(3) {*/
    /*  right: 0;*/
    /*  top: 183px;*/
    /*  width: 187px;*/
    /*  height: 216px;*/
    /*}*/
    /*&:nth-child(4) {*/
    /*  right: 115px;*/
    /*  top: 400px;*/
    /*  width: 187px;*/
    /*  height: 216px;*/
    /*}*/
  }
  .hd-text {
    color: #979797;
    font-size: 16px;
    line-height: 28px;
    margin-top: 30px;
  }
}
.imgPerIn-list {
  .g-box {
    display: flex;
    align-items: center;
  }
  .list-item {
    padding: 60px 0;
    & + .list-item {
      border-top: 1px solid #f0f0f0;
    }
  }
  .list-item-img {
    width: 188px;
    height: 216px;
    flex-shrink: 0;
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
  }
  .list-item-cent {
    width: 270px;
    flex-shrink: 0;
    margin-left: 50px;
  }
  .list-item-cap {
    color: #282828;
    font-size: 24px;
  }
  .list-item-tit {
    color: #606060;
    font-size: 16px;
    margin-top: 6px;
  }
  .list-item-text {
    color: #979797;
    font-size: 16px;
    margin-left: 20px;
    line-height: 22px;
  }
}
</style>
